class AccordingToYXUIDCheckTheInformation {
  /** 云信会议ID */
  channelId = undefined;

  /** 查询的用户云信uid列表 */
  yxUids = [];
}

class AnnexInformationInTheConferenceRecord {
  /** 附件类型 */
  category = undefined;

  /** 附件对应的云空间文档地址 */
  docUrl = '';

  /** 附件文件名 */
  name = '';
}

class AudioAndVideoConferenceLinkRegular {
  /** android */
  android = [];

  /** ios */
  ios = [];

  /** mac */
  mac = [];

  /** windows */
  windows = [];
}

class BriefInformationOfTheMeeting {
  /** 云信会议ID */
  channelId = undefined;

  /** 云信会议名称 */
  channelName = '';

  /** 会议ID */
  meetingId = undefined;

  /** 会议名称 */
  meetingName = '';
}

class CallParameter {
  /** 被呼叫用户uid集合 */
  callees = [];

  /** 云信会议房间ID */
  channelId = undefined;

  /** 被叫的 SIPDevice列表 */
  sipCallees = [];
}

class CallSignal {
  /** 呼叫头像 */
  callAvatar = '';

  /** 呼叫类型，参考 MeetingType 枚举 */
  callType = undefined;

  /** 被叫方uid */
  calleeName = '';

  /** 被叫方uid */
  calleeUid = '';

  /** 主叫方名称 */
  callerName = '';

  /** 主叫方uid */
  callerUid = '';

  /** 会议房间ID */
  channelId = undefined;

  /** 会议房间名 */
  channelName = '';

  /** CallSignal到期时间 */
  expiresAt = undefined;

  /** 是否 P2P 呼叫 */
  isP2pCalling = false;

  /** 会议号 */
  meetingId = undefined;

  /** 会议模式，参考 MeetingMode 枚举 */
  meetingMode = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 信号ID */
  signalId = '';
}

class CalledFangRefusedToAnswerParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 拒绝接听的CallSignalID */
  signalId = '';
}

class CancelTheCallParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 取消呼叫原因 参考 CancelCallReason 枚举 */
  reason = undefined;

  /** 取消呼叫的CallSignalID集合 */
  signalIds = [];
}

class CancelTheEntranceCheckParameter {
  /** 云信会议房间ID */
  channelId = undefined;
}

class CheckTheParameters {
  /** check-in 方式二：根据云信会议房间ID */
  channelId = undefined;

  /** 入会check的入口 */
  entrance = undefined;

  /** 入会check入口参数 */
  entranceExtraParam = '';

  /** 是否要发送首位入会通知 */
  firstMemberNotifyOn = undefined;

  /** check-in 方式一：根据会议ID */
  meetingId = undefined;

  /** operator */
  operator = '';

  /** 客户端输入的入会密码 */
  password = '';

  /** 日程开始时间 */
  scheduleSt = undefined;
}

class CodeEditorStatus {
  /** 开启代码编辑器的参会设备ID */
  codeEditorEnableDeviceId = '';

  /** 开启代码编辑器的参会人uid */
  codeEditorEnableUid = '';

  /** 代码编辑器是否开启 */
  codeEditorEnabled = false;

  /** 代码编辑器地址 */
  codeEditorUrl = '';
}

class CodePresetAtTheMeeting {
  /** 会议密码 */
  password = '';

  /** 是否启用密码 */
  passwordEnabled = false;

  /** 免密登录范围：1 - 日程参与人免密；2 - POPO 登录用户免密 */
  passwordFreeScope = undefined;
}

class ConferenceAppointmentResults {
  /** 会议预约结束时间，循环日程不适用该时间 */
  endTime = '';

  /** 扩展字段 */
  externField = '';

  /** externFieldMap */
  externFieldMap = undefined;

  /** 与source取值有关，日程预约是日程ID */
  externId = '';

  /** 会议ID */
  meetingId = undefined;

  /** 会议标题 */
  meetingTitle = '';

  /** PresetConfiguration */
  preset = new PresetConfiguration();

  /** 1: 日程预约会议 */
  source = undefined;

  /** 会议预约开始时间，循环日程不适用该时间 */
  startTime = '';

  /** web会议进入链接 */
  webMeetingLink = '';
}

class ConferenceConfigurationInformation {
  /** 聊天室相关信息 */
  chatRoomStatus = new MeetingChatRoomInformation();

  /** CodeEditorStatus */
  codeEditorStatus = new CodeEditorStatus();

  /** 会控相关信息 */
  controlStatus = new ControlInformation();

  /** FocusOnModeInformation */
  focusModeStatus = new FocusOnModeInformation();

  /** 举手中的参会设备 */
  handUpDevices = [];

  /** 主持人 */
  host = new ParticipatorInformationV3();

  /** SimilarInterpretationConfiguration */
  interpretStatus = new TheConferenceIsContemporaryInterpretationStatus();

  /** PasswordConfigurationInTheMeeting */
  passwordStatus = new PasswordConfigurationInTheMeeting();

  /** Reaction 配置 */
  reactionStatus = new ConferenceReactionConfiguration();

  /** 录制状态 */
  recordingStatus = new ConferenceRecordingStatus();

  /** 屏幕共享相关信息 */
  screenShareStatus = new ConferenceShareScreenStatusInformation();

  /** SIP入口状态 */
  sipStatus = new ExternalTerminalEntryState();

  /** 实时转录状态 */
  transcriptionStatus = new TranscriptionStatusInformation();

  /** ConferenceWebEntryConfigurationInformation */
  webEntranceStatus = new ConferenceWebEntryConfigurationInformation();

  /** 互动白板相关信息 */
  whiteboardStatus = new ConferenceInteractiveWhiteboardStatusInformation();
}

class ConferenceConfigurationItem {
  /** focusMode */
  focusMode = new SpeakerTestAlgorithmConfiguration();

  /** AudioAndVideoConferenceLinkRegular，各端自行编写正则，提交给服务端 */
  meetingUrlPatterns = new AudioAndVideoConferenceLinkRegular();

  /** 参会人动态排序配置 */
  memberDynamicSortSetting = new MemberDynamicSortSettingDto();

  /** muteEnterAlertDeviceNumLimit */
  muteEnterAlertDeviceNumLimit = undefined;

  /** Reaction 配置 */
  reactionSetting = new ReactionSettingDto();

  /** 机器人的云信账户 uid 集合，机器人用于字幕、转录、录制场景下加入云信会议房间 */
  robotYxMeetingUids = [];

  /** SIP相关配置 */
  sip = new SIPAttendeeAvatarConfiguration();

  /** 专注模式全局配置 */
  speakerDetectionSetting = new SpeakerTestAlgorithmConfiguration();

  /** win端兼容辅流的版本号 */
  streamCompatibleVersion = '';

  /** 音视频 STOMP 长连接服务端点。 */
  subtitleStompEndpoint = '';
}

class ConferenceInformationV3 {
  /** 会议开始时间戳，毫秒 */
  beginTime = undefined;

  /** 云信会议名房间ID */
  channelId = undefined;

  /** 云信会议房间名 */
  channelName = '';

  /** 聊天室相关信息 */
  chatRoomStatus = new MeetingChatRoomInformation();

  /** CodeEditorStatus */
  codeEditorStatus = new CodeEditorStatus();

  /** 会控相关信息 */
  controlStatus = new ControlInformation();

  /** 到当前时刻，会议持续的时间，毫秒 */
  currentDuration = undefined;

  /** 服务端当前时刻时间戳，毫秒 */
  currentTimestamp = undefined;

  /** 会议房间从开始到结束的时间，毫秒 */
  duration = undefined;

  /** 会议结束时间戳，毫秒 */
  endTime = undefined;

  /** 会议扩展字段ID */
  externId = '';

  /** FocusOnModeInformation */
  focusModeStatus = new FocusOnModeInformation();

  /** 主持人信息，即members属性中 role 为主持人的参会人，是一个冗余数据，用于快捷读取主持人 */
  host = new ParticipatorInformationV3();

  /** 会议ID */
  meetingId = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 参会人信息 */
  members = [];

  /** 会议模式，参考枚举 MeetingMode */
  mode = undefined;

  /** 用户发送通知的 STOMP 服务连接信息 */
  notifyStompAuth =
    new ConferenceNotifyTheAuthenticationInformationConnection();

  /** 会议的拥有者uid，不一定是主持人uid */
  ownerUid = '';

  /** PasswordConfigurationInTheMeeting */
  passwordStatus = new PasswordConfigurationInTheMeeting();

  /** 录制状态 */
  recordingStatus = new ConferenceRecordingStatus();

  /** 屏幕共享相关信息 */
  screenShareStatus = new ConferenceShareScreenStatusInformation();

  /** SIP入口状态 */
  sipStatus = new ExternalTerminalEntryState();

  /** 会议状态，参考枚举 MeetingStatus */
  status = undefined;

  /** 获取会议关联的群组ID，仅群组模式会议存在此字段 */
  teamId = '';

  /** 会议类型，参考枚举 MeetingType */
  type = undefined;

  /** ConferenceWebEntryConfigurationInformation */
  webEntranceStatus = new ConferenceWebEntryConfigurationInformation();

  /** 互动白板相关信息 */
  whiteboardStatus = new ConferenceInteractiveWhiteboardStatusInformation();

  /** 云信应用访问认证信息：G2音视频、IM即时通讯 */
  yxAuth = new G2AudioAndVideoParameter();
}

class ConferenceInteractiveWhiteboardStatusInformation {
  /** 互动白板开启的参会设备ID */
  wbEnableDeviceId = '';

  /** 互动白板开启权限 1-所有人可开启 2-仅主持人可开启 */
  wbEnablePermission = undefined;

  /** 开启互动白板的参会人uid */
  wbEnableUid = '';

  /** 互动白板是否已开启 */
  wbEnabled = false;

  /** InteractiveWhiteBanCloudCertificationParameters */
  wbYxAuthArgs = new InteractiveWhiteBanCloudCertificationParameters();
}

class ConferenceNotifyTheAuthenticationInformationConnection {
  /** STOMP 服务订阅地址，包含多个用于下发通知的 destination，都需要订阅 */
  stompDestinations = [];

  /** STOMP 服务连接地址，会拼接认证参数 */
  stompEndpoint = '';
}

class ConferenceReactionConfiguration {
  /** 是否已启用表情 Reaction */
  emoticonReactionEnabled = false;
}

class ConferenceRecord {
  /** 归档时间 */
  archivedAt = '';

  /** 归档时间，毫秒时间戳 */
  archivedAtTs = undefined;

  /** ConferenceRecord关联的附件类型数组，参考 AttachmentSource 枚举 */
  attachmentCategories = [];

  /** 如果是呼叫记录，表示被叫方uid */
  callee = '';

  /** 如果是呼叫记录，表示主叫方uid */
  caller = '';

  /** 会议云信房间ID */
  channelId = undefined;

  /** 会议云信房间名 */
  channelName = '';

  /** 如果此记录被折叠，此属性表示被折叠的ConferenceRecord */
  foldedRecordIds = [];

  /** 是否被叫方 */
  isCallee = false;

  /** 是否主叫方 */
  isCaller = false;

  /** 此记录是否被折叠 */
  isFolded = false;

  /** 会议号 */
  meetingId = undefined;

  /** 会议模式：1-双人会议，2-多人会议，3-日历会议，4-群组会议 */
  meetingMode = undefined;

  /** 会议标题 */
  meetingTitle = '';

  /** ConferenceRecordID */
  recordId = undefined;

  /** 记录状态：2-已入会，3-已离开，4-呼叫中，5-主叫取消呼叫，6-超时主叫取消呼叫，7-已拒绝 */
  recordState = undefined;
}

class ConferenceRecordingRelatedStatus {
  /** 是否允许参会人分享会议录制文件，如不传递则默认禁止 */
  isShareableForMember = false;

  /** 是否开启录制文件水印，如不传递则默认开启水印 */
  isWatermarkEnabled = false;

  /** ConferenceRecordingStatus，1-录制中，2-已暂停，3-已停止；默认状态 3-已停止。 */
  status = undefined;
}

class ConferenceRecordingStatus {
  /** 是否允许参会人共享录制文件 */
  isShareableForMember = false;

  /** 是否开启水印 */
  isWatermarkEnabled = false;

  /** ConferenceRecordingStatus */
  status = undefined;
}

class ConferenceShareScreenStatusInformation {
  /** 批注是否可以保存快照 */
  canSaveAnnotateSnapshot = false;

  /** 共享屏幕批注是否已开启 */
  shareAnnotateEnabled = false;

  /** 共享屏幕批注权限 参考枚举 ShareAnnotatePermission */
  shareAnnotatePermission = undefined;

  /** 共享批注白板云信认证参数 */
  shareAnnotateWbYxAuthArgs =
    new InteractiveWhiteBanCloudCertificationParameters();

  /** 屏幕共享是否已开启 */
  shareEnabled = false;

  /** 正在进行屏幕共享的参会人设备ID */
  shareMemberDeviceId = '';

  /** 屏幕共享中的参会人uid */
  shareMemberUid = '';

  /** 共享屏幕权限 参考枚举 SharePermission */
  sharePermission = undefined;

  /** 共享屏幕抢断权限 参考枚举 ShareSnatchPermission */
  shareSnatchPermission = undefined;

  /** 共享源窗口高度，物理像素 */
  shareSourceHeight = undefined;

  /** 共享源窗口宽度，物理像素 */
  shareSourceWidth = undefined;
}

class ConferenceTranslatorConfiguration {
  /** 译员参会设备ID，如译员未入会此字段为 null */
  deviceId = '';

  /** 译员互译源语言名称 */
  fromLanguageName = '';

  /** 译员互译源语言名称，简写形式，用于标签展示，如：中、英、zh、en */
  fromLanguageNameShort = '';

  /** 译员互译源语言 tag */
  fromLanguageTag = '';

  /** 译员麦克风状态；1-开启，2-关闭 */
  mikeStatus = undefined;

  /** 译员输出频道的传译语言标签，如果是方言则直接是方言名称。如果输出到主频道，则此字段为空字符串。 */
  outputChannelLanguage = '';

  /** 译员互译目标语言名称 */
  toLanguageName = '';

  /** 译员互译目标语言名称简写形式，用于标签展示，如：中、英、zh、en */
  toLanguageNameShort = '';

  /** 译员互译目标语言 tag */
  toLanguageTag = '';

  /** 译员用户 uid */
  uid = '';

  /** 译员参会设备的云信账号uid，如译员未入会此字段为 null */
  yxMeetingUid = undefined;
}

class ConferenceWebEntryConfigurationInformation {
  /** 是否允许web端入会 */
  webEnabled = false;

  /** web端入会链接 */
  webMeetingLink = '';
}

class ConfigurationParametersOfTheSameInterpreter {
  /** 传译源语言 */
  fromLanguage = '';

  /** 传译目标语言 */
  toLanguage = '';

  /** 译员 uid */
  uid = '';

  /** 译员参会设备的云信账号 uid */
  yxMeetingUid = undefined;
}

class ControlConfiguration {
  /** 加入房间是否默认静音 */
  isMuteEnter = false;

  /** 是否只能主持人邀请参会人 */
  onlyOwnerInvite = false;
}

class ControlInformation {
  /** 会中邀请权限：1-所有人可邀请，2-仅主持人可邀请 */
  invitePrivilege = undefined;

  /** 麦克风控制模式是否开启 */
  mickControlOn = false;

  /** 开启麦克风的人数上限 */
  mikeOnLimit = undefined;

  /** 新加入参会人是否静音 */
  muteEnter = false;

  /** 新加入参会人是否静音 按钮是否禁止修改 */
  muteEnterDisabled = false;
}

class CreateParametersOfTheScheduleMeeting {
  /** 被邀请者的popo账号 */
  attendees = [];

  /** ControlConfiguration */
  controlSetting = new ControlConfiguration();

  /** externId */
  externId = '';

  /** 会议号 */
  meetingId = undefined;

  /** meetingMode */
  meetingMode = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 会议拥有者 */
  meetingOwner = '';

  /** 房间类型，1-音频，2-视频 */
  meetingType = undefined;

  /** 日程ID */
  scheduleId = '';
}

class DetailsOfTheMeetingRecord {
  /** 会议附件列表 */
  attachments = [];

  /** 如果用户是主叫方，表示被叫方用户uid */
  callee = '';

  /** 如果用户是被叫方，表示主叫方用户uid */
  caller = '';

  /** 如果是P2P会议，此记录中用户是否为被叫方 */
  isCallee = false;

  /** 如果是P2P会议，此记录中用户是否为主叫方 */
  isCaller = false;

  /** 会议关联ID，如果是日历会议，则表示日历ID */
  meetingExternId = '';

  /** 会议模式：1-P2P会议，2-多人会议，3-日历会议，4-群组会议 */
  meetingMode = undefined;

  /** 会议开始时间 */
  meetingStartAt = '';

  /** 会议开始时间，毫秒时间戳 */
  meetingStartAtTs = undefined;

  /** 会议结束时间 */
  meetingStopAt = '';

  /** 会议结束时间，毫秒时间戳 */
  meetingStopAtTs = undefined;

  /** 会议标题 */
  meetingTitle = '';

  /** 用户轨迹时间线 */
  timeline = [];
}

class ExternalTerminalEntryState {
  /** 内线话机呼叫的号码；或外线话机呼叫中继号码后，继续输入的会议号码 */
  sipChannelId = '';

  /** 内线话机呼叫的号码的展示字段 */
  sipChannelIdDisplay = '';

  /** 外线话机呼叫的中继号码 */
  sipRelayNumber = '';

  /** 外部终端入会是否开启 */
  terminalEntranceEnabled = false;
}

class FailureToQueryParametersWithoutList {
  /** 会议房间 ID */
  channelId = undefined;

  /** queryAll */
  queryAll = false;

  /** uid 集合 */
  uids = [];
}

class Feedback {
  /** Feedback */
  doc = '';

  /** id */
  id = undefined;

  /** Feedback语言，参考系统Locale */
  language = '';

  /** Feedback类型，参考枚举 FeedbackDocType */
  type = undefined;
}

class FocusOnModeInformation {
  /** 专注模式状态：1-开启、2-关闭 */
  focusModeStatus = undefined;

  /** 专注模式开启时，关注的参会人设备ID */
  focusOnMemberDeviceId = '';

  /** 专注模式关注的参会人uid */
  focusOnMemberUid = '';
}

class FocusOnModeModificationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 专注模式状态，1-开启、2-关闭 */
  focusModeStatus = undefined;

  /** 开启专注模式时，聚焦的参会设备ID */
  focusOnMemberDeviceId = '';

  /** 开启专注模式时，聚焦的参会人uid */
  focusOnMemberUid = '';
}

class G2AudioAndVideoParameter {
  /** imAccid */
  imAccid = '';

  /** imToken */
  imToken = '';

  /** 云信G2音视频应用AppId */
  yxMeetingAppId = undefined;

  /** 云信G2音视频应用AppKey */
  yxMeetingAppKey = '';

  /** yxMeetingToken */
  yxMeetingToken = '';

  /** yxMeetingUid */
  yxMeetingUid = undefined;
}

class GroupMeetingInformation {
  /** 会议开始时间戳，毫秒 */
  beginTime = undefined;

  /** 云信会议名房间ID */
  channelId = undefined;

  /** 云信会议房间名 */
  channelName = '';

  /** 聊天室相关信息 */
  chatRoomStatus = new MeetingChatRoomInformation();

  /** CodeEditorStatus */
  codeEditorStatus = new CodeEditorStatus();

  /** 会控相关信息 */
  controlStatus = new ControlInformation();

  /** 到当前时刻，会议持续的时间，毫秒 */
  currentDuration = undefined;

  /** 服务端当前时刻时间戳，毫秒 */
  currentTimestamp = undefined;

  /** 会议房间从开始到结束的时间，毫秒 */
  duration = undefined;

  /** 会议结束时间戳，毫秒 */
  endTime = undefined;

  /** 会议扩展字段ID */
  externId = '';

  /** FocusOnModeInformation */
  focusModeStatus = new FocusOnModeInformation();

  /** 主持人信息，即members属性中 role 为主持人的参会人，是一个冗余数据，用于快捷读取主持人 */
  host = new ParticipatorInformationV3();

  /** 会议ID */
  meetingId = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 参会人信息 */
  members = [];

  /** 会议模式，参考枚举 MeetingMode */
  mode = undefined;

  /** 用户发送通知的 STOMP 服务连接信息 */
  notifyStompAuth =
    new ConferenceNotifyTheAuthenticationInformationConnection();

  /** 会议的拥有者uid，不一定是主持人uid */
  ownerUid = '';

  /** PasswordConfigurationInTheMeeting */
  passwordStatus = new PasswordConfigurationInTheMeeting();

  /** 录制状态 */
  recordingStatus = new ConferenceRecordingStatus();

  /** 屏幕共享相关信息 */
  screenShareStatus = new ConferenceShareScreenStatusInformation();

  /** SIP入口状态 */
  sipStatus = new ExternalTerminalEntryState();

  /** 会议状态，参考枚举 MeetingStatus */
  status = undefined;

  /** 群组ID，群组模式会议时才返回有效值，其他模式会议返回null */
  teamId = '';

  /** 会议类型，参考枚举 MeetingType */
  type = undefined;

  /** ConferenceWebEntryConfigurationInformation */
  webEntranceStatus = new ConferenceWebEntryConfigurationInformation();

  /** 互动白板相关信息 */
  whiteboardStatus = new ConferenceInteractiveWhiteboardStatusInformation();

  /** 云信应用访问认证信息：G2音视频、IM即时通讯 */
  yxAuth = new G2AudioAndVideoParameter();
}

class GroupMeetingsCreateParameters {
  /** 被邀请者的popo账号 */
  attendees = [];

  /** ControlConfiguration */
  controlSetting = new ControlConfiguration();

  /** 会议名称 */
  meetingName = '';

  /** 会议拥有者 */
  meetingOwner = '';

  /** 房间类型，1-音频，2-视频 */
  meetingType = undefined;

  /** 群组ID */
  teamId = '';
}

class HighlightInformation {
  /** 高亮的起始字符索引，索引从 0 开始 */
  begin = undefined;

  /** 高亮的结束字符索引，索引从 0 开始 */
  end = undefined;

  /** 高亮的字段，取值：name、memo */
  field = '';
}

class InteractiveWhiteBanCloudCertificationParameters {
  /** Android 白板页面访问地址 */
  androidWhiteboardUrl = '';

  /** 白板应用的云信 appkey */
  appkey = '';

  /** 生成的签名值 */
  checksum = '';

  /** 秒级时间戳 */
  curTime = '';

  /** iOS 白板页面访问地址 */
  iosWhiteboardUrl = '';

  /** iPad 白板页面访问地址 */
  ipadWhiteboardUrl = '';

  /** 随机的 128 位以内的字符串 */
  nonce = '';

  /** 白板房间ID */
  whiteboardChannelId = '';

  /** PC 白板页面访问地址 */
  whiteboardUrl = '';
}

class InteractiveWhiteboardSnapshotFileUploadParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** base64格式的图片文件 */
  fileBase64 = '';

  /** 文件扩展名，也即文件后缀，如 png */
  fileNameExtension = '';
}

class InterpretationCanBeAvailable {
  /** 当前语言名称的所有国际化展示文案，自定义方言不返回此字段，key - 国家缩写小写（如zh\ja\en），value - 国际化文案 */
  i18nNames = undefined;

  /** 语言名称简写形式，用于标签展示，自定义方言不返回此字段，key - 国家缩写小写（如zh\ja\en），value - 国际化文案 */
  i18nShortNames = undefined;

  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** 语言名称，根据入参 Locale 国际化 */
  name = '';

  /** 语言名称简写形式，用于标签展示，如：中、英、zh、en */
  shortName = '';

  /** 语言标签 */
  tag = '';
}

class InterpretationLanguageChannel {
  /** 传译LanguageSubChannel列表 */
  channels = [];
}

class InterpretationVoiceChannelSubscriptionParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** LanguageChannelSubscriptionInformation */
  subscriptions = [];

  /** 是否订阅伙伴频道，1-是，0-否； */
  withPartnerChannels = undefined;
}

class JSONResponseObjectPackaging {
  /** 返回的数据对象 */
  data = new G2AudioAndVideoParameter();

  /** 提示消息 */
  message = '';

  /** 状态 1成功 */
  status = undefined;
}

class LanguageChannelSubscriptionInformation {
  /** languageTag */
  languageTag = '';
}

class LanguageOption {
  /** 语言代码，如：zh-CHS。 */
  language = '';

  /** 语言名称，如：中文。 */
  name = '';
}

class LanguageSubChannel {
  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** InterpretationLanguageChannel展示名，已根据 Locale 国际化。如果是方言频道，则 tag 值为方言名称。 */
  languageName = '';

  /** InterpretationLanguageChannel的语言 tag。如果是方言频道，则 tag 值为方言名称。 */
  languageTag = '';

  /** 云信子房间名 */
  yxSubchannelName = '';
}

class MeetingApplication {
  /** 应用描述 */
  appDesc = '';

  /** 应用ID */
  appId = '';

  /** 应用名称 */
  appName = '';
}

class MeetingChatRoomInformation {
  /** 连接云信聊天室使用的appKey */
  appKey = '';

  /** 聊天室是否开启 */
  chatRoomEnabled = false;

  /** 聊天室ID */
  chatRoomId = undefined;

  /** 用户在云信IM系统中的ID */
  yxImAccid = '';

  /** 用户在云信IM系统中的token */
  yxImToken = '';
}

class MeetingRecordDetailsQueryParameters {
  /** 查询操作用户uid，客户端不必传 */
  operator = '';

  /** 记录ID */
  recordId = undefined;
}

class MemberDynamicSortSettingDto {
  /** 计算发言次数的参考时长，秒。默认 30 分钟，1800 秒 */
  speakingReferenceDuration = undefined;
}

class ModeratorHandlesRecordingApplicationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** RecordingConfigurationItem，允许录制时必传 */
  setting = new RecordingConfigurationItem();

  /** 主持人的处理方式，参考枚举 ControlRequestTreatment */
  treatment = undefined;
}

class ModeratorModifyTheTitleParametersMeeting {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 会议标题 */
  meetingName = '';
}

class ModeratorOperatingEquipmentCameraParameters {
  /** 摄像头状态，参考 PeripheralStatus 枚举 */
  cameraStatus = undefined;

  /** 云信会议房间ID */
  channelId = undefined;

  /** 备操作的参会设备ID */
  operatedMemberDeviceId = '';

  /** 被操作的参会人uid */
  operatedMemberUid = '';
}

class ModeratorOperatingEquipmentMicrophoneParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 麦克风状态，参考 PeripheralStatus 枚举 */
  mikeStatus = undefined;

  /** 打开麦克风的方式：1-手动打开且保持开启；2-按住空格键临时开启。默认取值 1 。 */
  mode = undefined;

  /** 备操作的参会设备ID */
  operatedMemberDeviceId = '';

  /** 被操作的参会人uid */
  operatedMemberUid = '';
}

class ModeratorProcessingTranscriptionApplicationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 是否分享转录文档给所有参会人 */
  shareToAll = false;

  /** 主持人的处理方式，参考枚举 ControlRequestTreatment */
  treatment = undefined;
}

class ModeratorTransferParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 新主持人设备ID */
  newHostDeviceId = '';

  /** 新主持人uid */
  newHostUid = '';
}

class ModifyTheChatRoomParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 聊天室状态，参考枚举 ChatRoomStatus */
  chatRoomStatus = undefined;
}

class ModifyTheConferenceReactionConfigurationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 表情 Reaction 开关状态 */
  emoticonReactionEnabled = false;
}

class ModifyThePasswordConfigurationParametersMeeting {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 是否启用密码 */
  passwordEnabled = false;

  /** 免密登录范围：1 - 日程参与人免密；2 - POPO 登录用户免密 */
  passwordFreeScopes = [];
}

class ModifyTheRecordingConfigurationParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** RecordingConfigurationItem */
  setting = new RecordingConfigurationItem();
}

class ModifyTheSharedScreenPermissionParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享屏幕权限，参考枚举 SharePermission */
  permission = undefined;
}

class ModifyTheSharedScreenStealsParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享屏幕抢断权限，参考枚举 ShareSnatchPermission */
  snatchPermission = undefined;
}

class ModifyTheWebEntryParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** web入口状态，参考枚举 WebEntranceStatus */
  webEntranceStatus = undefined;
}

class MultipatedMeetingsToCreateParameters {
  /** 被邀请者的popo账号 */
  attendees = [];

  /** ControlConfiguration */
  controlSetting = new ControlConfiguration();

  /** externId */
  externId = '';

  /** meetingMode */
  meetingMode = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 会议拥有者 */
  meetingOwner = '';

  /** 房间类型，1-音频，2-视频 */
  meetingType = undefined;
}

class OpenTheConferenceRecordingParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** RecordingConfigurationItem */
  setting = new RecordingConfigurationItem();
}

class OpenTheTranscriptionParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 是否分享转录文档给所有参会人 */
  shareToAll = false;
}

class P2PMeetingToParameters {
  /** 被邀请者的popo账号 */
  attendees = [];

  /** ControlConfiguration */
  controlSetting = new ControlConfiguration();

  /** externId */
  externId = '';

  /** meetingMode */
  meetingMode = undefined;

  /** 会议名称 */
  meetingName = '';

  /** 会议拥有者 */
  meetingOwner = '';

  /** 房间类型，1-音频，2-视频 */
  meetingType = undefined;
}

class ParticipantCallResult {
  /** 被呼叫的参会人名称 */
  memberName = '';

  /** ParticipantCallResult：1-成功 2-对方已在会议中 3-对方忙碌 4-对方被踢出 */
  result = undefined;

  /** CallSignalID */
  signalId = '';

  /** 被呼叫的参会人uid */
  uid = '';
}

class ParticipantsSubscribeToTheSubChannel {
  /** 音频 ASL 选路黑名单，云信账户 uid 集合 */
  audioAslBlacklist = [];

  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** InterpretationLanguageChannel展示名，已根据 Locale 国际化。如果是方言频道，则 tag 值为方言名称。 */
  languageName = '';

  /** InterpretationLanguageChannel的语言 tag。如果是方言频道，则 tag 值为方言名称。 */
  languageTag = '';

  /** 云信子房间名 */
  yxSubchannelName = '';
}

class ParticipateTheExteriorOfTheStatus {
  /** 参会设备uid */
  memberDeviceId = '';

  /** 参会人名称 */
  memberName = '';

  /** 参会人uid */
  memberUid = '';

  /** 开麦申请令牌 */
  requestToken = '';
}

class ParticipatingEquipmentModifyYourOwnParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 麦克风状态，参考 PeripheralStatus 枚举 */
  mikeStatus = undefined;

  /** 打开麦克风的方式：1-手动打开且保持开启；2-按住空格键临时开启。默认取值 1 。 */
  mode = undefined;
}

class ParticipatingEquipmentPeripherals {
  /** 外设状态，参考枚举 PeripheralStatus */
  peripheralStatus = undefined;

  /** 外设类型，参考枚举 PeripheralType */
  peripheralType = undefined;
}

class ParticipatingEquipmentThatIsRaisingHand {
  /** 参会设备 ID */
  deviceId = '';

  /** 举手时的时间戳，毫秒 */
  timestamp = undefined;

  /** 参会人 uid */
  uid = '';

  /** 优先用 uid+deviceId 匹配参会设备，不建议使用此字段。参会设备的云信账号 uid。 */
  yxMeetingUid = undefined;
}

class ParticipatorInformationV3 {
  /** 参会人check本场会议时，传递的popo客户端版本号 */
  appVersion = '';

  /** 未入会列表中的参会人，被呼叫时的类型：0-POPO用户，1-会议室，2-话机，3-手机 */
  calleeType = undefined;

  /** 成员所属部门，web端游客无此字段 */
  department = '';

  /** 参会人check本场会议时，使用的客户端设备ID */
  deviceId = '';

  /** 参会人check本场会议时，使用的客户端设备名称 */
  deviceName = '';

  /** 参会人check本场会议时，使用的客户端类型，参考{@link DeviceType} */
  deviceType = undefined;

  /** 成员进入房间时间戳 */
  enterTime = undefined;

  /** TheInformationThatTheParticipantTime。仅未入会参会人返回此字段。注意：calleeType 值为 -1 时，此字段为 null，请谨慎处理！ */
  lastCall = new TheInformationThatTheParticipantTime();

  /** 成员头像地址 */
  memberAvatarUrl = '';

  /** 成员显示名称 */
  memberName = '';

  /** 成员手机号，web端游客无此字段 */
  phoneNumber = '';

  /** 用户角色，参考 MemberRole */
  role = undefined;

  /** 参会人状态，参考 MemberStatus */
  status = undefined;

  /** popo账号是邮箱，游客用户是游客ID */
  uid = '';

  /** 云信IM用户id */
  yxImAccid = '';

  /** 云信音视频用户uid */
  yxUid = undefined;

  /** yxUid的字符串格式，web端防止精度丢失用 */
  yxUidStr = '';
}

class PasswordConfigurationInTheMeeting {
  /** 会议密码 */
  password = '';

  /** 是否启用密码 */
  passwordEnabled = false;

  /** 免密登录范围：1 - 日程参与人免密；2 - POPO 登录用户免密 */
  passwordFreeScopes = [];
}

class PresetConfiguration {
  /** 入会议权限控制：1-所有人可加入，2-仅日程参与人可加入 */
  enterPrivilege = undefined;

  /** SimilarInterpretationConfiguration */
  interpret = new SimilarInterpretationConfiguration();

  /** 新成员是否静音加入房间 */
  isMuteEnter = false;

  /** 密码预设 */
  password = new CodePresetAtTheMeeting();

  /** 内线话机呼叫的号码；或外线话机呼叫中继号码后，继续输入的会议号码 */
  sipChannelId = '';

  /** 内线话机呼叫的号码的展示字段 */
  sipChannelIdDisplay = '';

  /** 外线话机呼叫的中继号码 */
  sipRelayNumber = '';

  /** 是否允许外部终端入会 */
  terminalEntranceEnabled = false;

  /** 是否允许成员通过浏览器入会 */
  webEnabled = false;
}

class ReactionAvailableExpression {
  /** 表情的 Webp 动画时长，毫秒 */
  animationWebpDuration = undefined;

  /** 动画 Webp 图地址后缀。与前缀拼接为 FP 图片访问地址，是一个大图，如果需要不同尺寸可以拼接 fop 参数。 */
  animationWebpSuffix = '';

  /** 表情 ID */
  emoticonId = '';

  /** 表情名称，已经过国际化处理 */
  emoticonName = '';

  /** 排序序号 */
  index = undefined;

  /** 静态 Webp 图地址后缀。与前缀拼接为 FP 图片访问地址，是一个大图，如果需要不同尺寸可以拼接 fop 参数。 */
  staticWebpSuffix = '';
}

class ReactionCanUseTheEmojiList {
  /** 表情列表 */
  emoticons = [];

  /** 表情资源地址前缀，如：https://popofp.vipfp.ps.netease.com/file */
  urlPrefix = '';
}

class ReactionSettingDto {
  /** 举手动态图 */
  handUpAnimWebp = '';

  /** 举手动态图动画时长，毫秒 */
  handUpAnimWebpDuration = undefined;

  /** 举手静态图 */
  handUpStaticWebp = '';
}

class RecordingConfigurationItem {
  /** 是否允许参会人分享会议录制文件，如不传递则默认禁止 */
  isShareableForMember = false;

  /** 是否开启录制文件水印，如不传递则默认开启水印 */
  isWatermarkEnabled = false;

  /** 是否分享录制文档给所有参会人 */
  shareToAll = false;
}

class ReportExternalStatusParametersOnEquipment {
  /** 云信会议房间ID */
  channelId = undefined;

  /** ParticipatingEquipmentPeripherals，可批量上报多个外设状态 */
  status = [];
}

class SIPAttendeeAvatarConfiguration {
  /** SIP参会人，移动终端默认头像 */
  sipPhoneDefaultAvatar = '';

  /** 外线话机呼叫的中继号码 */
  sipRelayNumber = '';

  /** SIP参会人，会议室默认头像 */
  sipRoomDefaultAvatar = '';
}

class SIPDevice {
  /** 此设备是否已经加入会议 */
  entered = false;

  /** HighlightInformation列表 */
  highlights = [];

  /** 会议室 ID。会议室类型结果返回此字段，否则返回空字符串。 */
  meetingRoomId = '';

  /** 搜索结果备注：会议室类型，是会议室地理位置；话机类型，是固定字符串 “座机/设备号码”； */
  memo = '';

  /** 搜索结果名称: 会议室类型，表示会议室名称+话机号码；话机类型，表示话机号码； */
  name = '';

  /** SIPDevice类型：1-会议室，2-话机 */
  sipCalleeType = undefined;

  /** SIPDevice号码 */
  sipNumber = '';
}

class SIPDeviceIcon {
  /** SIPDeviceIcon URL */
  icon = '';

  /** SIPDevice类型：1-会议室，2-话机 */
  sipCalleeType = undefined;
}

class SIPDeviceSearchResults {
  /** SIPDeviceIcon列表 */
  sipDeviceIcons = [];

  /** SIPDevice列表 */
  sipDevices = [];
}

class SIPIsCalledSquareInformation {
  /** 会议室 ID，sipCalleeType=1 时，传递此字段 */
  meetingRoomId = '';

  /** SIPDevice头像地址。sipCalleeType=3 时传递此参数，其他场景下服务端忽略此参数。 */
  sipAvatarUrl = '';

  /** SIP 被叫方类型：1-会议室，2-话机，3-手机 */
  sipCalleeType = undefined;

  /** SIPDevice名称 */
  sipName = '';

  /** 被叫的 SIPDevice号码 */
  sipNumber = '';
}

class SendEmojiParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 表情 ID */
  emoticonId = '';
}

class ShareScreenAnnotationPermissionsModificationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享屏幕批注权限 1-所有人可批注 2-仅主持人可批注 */
  permission = undefined;
}

class ShareScreenStatusModificationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享屏幕状态，参考枚举 ScreenShareStatus  */
  shareStatus = undefined;
}

class ShareSourceWindowSizeChangesParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 共享源窗口高度，物理像素 */
  sourceHeight = undefined;

  /** 共享源窗口宽度，物理像素 */
  sourceWidth = undefined;
}

class SimilarInterpretationConfiguration {
  /** 是否自动开启同声传译 */
  autoActive = false;

  /** TranslatorConfiguration */
  interpreters = [];
}

class SimilarInterpretationStatusModificationParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** interpreters */
  interpreters = [];

  /** 同声传译状态：1-停止，2-开启 */
  status = undefined;
}

class SpeakerEnterAlgorithmV1Dto {
  /** 过滤窗口时间内有音量回调的比率低于此值的用户，减少干扰。如：80% */
  ignoreCallbackRateLessThan = undefined;

  /** 过滤音量小于此值的用户，减少干扰。如：20 */
  ignoreVolumeLessThan = undefined;

  /** 音量检测滑动窗长度，毫秒，如：2000 */
  volumeDetectWindowMs = undefined;
}

class SpeakerLeaveAlgorithmV1Dto {
  /** 过滤窗口时间内有音量回调的比率低于此值的用户，减少干扰。如：80% */
  ignoreCallbackRateLessThan = undefined;

  /** 音量检测滑动窗长度，毫秒，如：2000 */
  volumeDetectWindowMs = undefined;
}

class SpeakerTestAlgorithmConfiguration {
  /** 专注时，发言人视频流小窗出现算法（v1）参数 */
  speakerEnterAlgorithmV1 = new SpeakerEnterAlgorithmV1Dto();

  /** 专注时，发言人视频流小窗消失算法（v1）参数 */
  speakerLeaveAlgorithmV1 = new SpeakerLeaveAlgorithmV1Dto();
}

class StreamingPaginationDataPackaging {
  /** 分页数据 */
  data = [];

  /** 是否存在更多记录 */
  hasMore = false;
}

class SubmitTheFeedbackParametersOfMeeting {
  /** 云信会议房间ID */
  channelId = undefined;

  /** FeedbackID */
  feedbackDocIds = [];

  /** 反馈操作类型，参考 FeedbackOperation 枚举 */
  feedbackOperation = '';

  /** 反馈类型，参考 FeedbackType 枚举 */
  feedbackType = undefined;

  /** 是否点赞 */
  isGreat = false;

  /** operator */
  operator = '';

  /** 反馈建议 */
  remark = '';
}

class SubtitleStompConnectionAuthenticationInformation {
  /** 字幕 STOMP 服务订阅地址 */
  stompDestination = '';

  /** 字幕 STOMP 服务连接地址，会拼接认证参数 */
  stompEndpoint = '';
}

class SubtitleTurnOnResultDto {
  /** 字幕作业流水号 */
  jobSerialId = undefined;

  /** 字幕 STOMP 服务认证 code */
  stompAuthCode = '';

  /** 字幕 STOMP 服务认证 token */
  stompAuthToken = '';

  /** 字幕 STOMP 服务订阅地址 */
  stompDestination = '';

  /** 字幕 STOMP 服务连接地址 */
  stompEndpoint = '';

  /** 此次开启字幕的订阅ID */
  subscriptionId = '';
}

class SwitchSubtitleLanguageParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕识别语言类型 */
  language = '';

  /** 当前字幕订阅ID */
  subscriptionId = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class SwitchTranscriptionLanguageParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 转录语言，传值与字幕相同 */
  language = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class TextAvatar {
  /** 头像图片地址 */
  avatarUrl = '';

  /** 头像中写入的文字内容 */
  text = '';
}

class TheConferenceIsContemporaryInterpretationStatus {
  /** 同声传译状态：1-停止，2-开启 */
  interpretationStatus = undefined;

  /** TranslatorConfiguration */
  interpreters = [];
}

class TheHostModifyTheExternalParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 外部终端入口是否开启 */
  entranceEnabled = false;
}

class TheHostPutDownTheParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 被放下手的参会设备 ID，所有人放下手时不传递此参数 */
  operatedDeviceId = '';

  /** 被放下手的参会人 uid，所有人放下手时不传递此参数 */
  operatedMemberUid = '';
}

class TheHostReviseWhetherTheConfiguration {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 新入会设备是否默认静音 */
  muteEnter = false;
}

class TheHostsInvitationPermissionsParametersMeeting {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 会中邀请权限，参考枚举 InvitePrivilege */
  privilege = undefined;
}

class TheHostsMicrophoneToTurnParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 请求开启麦克风的参会设备ID */
  requestMemberDeviceId = '';

  /** 请求开启麦克风的参会人uid */
  requestMemberUid = '';

  /** 麦克风开启请求的令牌 */
  requestToken = '';

  /** 主持人的处理结果，参考 ControlRequestTreatment 枚举 */
  treatment = undefined;
}

class TheInformationThatTheParticipantTime {
  /** 上次被呼叫时，主叫方设备 ID； */
  callerDeviceId = '';

  /** 上次被呼叫时，主叫方 uid； */
  callerUid = '';

  /** 上次被CallSignal状态：
1-呼叫中
2-已取消，主叫方主动取消
3-已取消，超时取消
4-被叫方拒绝接听
7-排队中，等待呼叫
8-呼叫失败 */
  signalStatus = undefined;

  /** 向 SIP 参会人发起呼叫时的参数。注意：calleeType 值为 1\2\3 时，此字段有值，否则赋值为 null，请谨慎处理！ */
  sipCallParam = new SIPIsCalledSquareInformation();
}

class TheLanguageAvailableInSubtitles {
  /** 实时语音识别 可用的语言类型。 */
  asrLanguages = [];

  /** 实时语音翻译 可用的翻译目标语言类型。实时语音翻译的源语言类型无需指定。 */
  astTargetLanguages = [];

  /** 实时语音识别 默认语言类型，根据客户端 Locale 决定。 */
  defaultAsrLanguage = new LanguageOption();

  /** 实时语音翻译 默认翻译目标语言类型，根据客户端 Locale 决定。 */
  defaultAstTargetLanguage = new LanguageOption();
}

class TheMeetingNoticeACKParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 会议号 */
  meetingId = undefined;

  /** ACK 的通知体中携带的版本号 */
  version = undefined;
}

class TheTranslatorModifyTheOutputResults {
  /** 客户端渲染语言图标时使用的文本 */
  iconWord = '';

  /** InterpretationLanguageChannel展示名，已根据 Locale 国际化。如果是方言频道，则 tag 值为方言名称。 */
  languageName = '';

  /** InterpretationLanguageChannel的语言 tag。如果是方言频道，则 tag 值为方言名称。 */
  languageTag = '';

  /** 云信子房间的认证信息 */
  yxSubchannelAuth = new G2AudioAndVideoParameter();

  /** 云信子房间名 */
  yxSubchannelName = '';
}

class TimelineNode {
  /** 持续时间，秒 */
  duration = undefined;

  /** 会议通话类型 1-音频通话 2-视频通话 */
  meetingType = undefined;

  /** 轨迹状态：2-已入会，3-已离开，4-呼叫中，5-主叫取消呼叫，6-超时主叫取消呼叫，7-已拒绝 */
  state = undefined;

  /** 时间点 */
  time = '';

  /** 时间点，毫秒时间戳 */
  timestamp = undefined;
}

class Transcription {
  /** id */
  id = undefined;

  /** name */
  name = '';

  /** speakerYxMeetingUid */
  speakerYxMeetingUid = undefined;

  /** subtitleContent */
  subtitleContent = '';

  /** timestamp */
  timestamp = undefined;

  /** uid */
  uid = '';

  /** url */
  url = '';
}

class TranscriptionStatusInformation {
  /** 转录 Web 组件地址 */
  transcriptionComponentUrl = '';

  /** 转录状态 */
  transcriptionStatus = undefined;
}

class TranslatorCandidate {
  /** 参会设备类型 */
  deviceType = undefined;

  /** 是否已经被指派为译员 */
  isInterpreter = false;

  /** 成员头像地址 */
  memberAvatarUrl = '';

  /** 成员显示名称 */
  memberName = '';

  /** 参会人 uid */
  memberUid = '';

  /** 参会设备的云信账户 uid */
  yxMeetingUid = undefined;
}

class TranslatorCandidateSearchResults {
  /** candidates */
  candidates = [];

  /** searchId */
  searchId = '';
}

class TranslatorConfiguration {
  /** 传译源语言 */
  fromLanguage = '';

  /** 传译目标语言 */
  toLanguage = '';

  /** 译员 uid */
  uid = '';
}

class TranslatorConfigurationModificationParameter {
  /** 云信会议房间ID */
  channelId = undefined;

  /** interpreters */
  interpreters = [];
}

class TranslatorsModifyTheVoiceOutputParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 切换至的输出频道的语言 tag；如果切换至方言频道，则直接传递方言名称；如切换至主频道，传递空字符串； */
  outputLanguage = '';
}

class TurnOffSubtitleParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕订阅ID */
  subscriptionId = '';
}

class TurnOnSubtitleParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 字幕识别语言类型 */
  language = '';

  /** 是否需要翻译，默认false */
  translate = false;

  /** 如需翻译，翻译至的目标语言 */
  translateTargetLanguage = '';
}

class UserMeetingSettingInitForm {
  /** 入会后自动开启字幕: -1 - 未设置、0 - 关闭、1 - 开启；不传会当做 -1 处理 */
  autoTurnOnSubtitle = undefined;
}

class UserMeetingSettingUpdateForm {
  /** AI 降噪：0-关闭、1-开启 */
  aiNoiseReduction = undefined;

  /** 入会后自动开启字幕: 0 - 关闭、1 - 开启 */
  autoTurnOnSubtitle = undefined;
}

class UserOperationParameters {
  /** 云信会议房间ID */
  channelId = undefined;
}

class WhiteboardExpressExportResult {
  /** 白板快照文件是否允许分享 */
  isShareable = false;
}

class WhiteboardSwitchParameters {
  /** 云信会议房间ID */
  channelId = undefined;

  /** 白板操作权限：1-所有人可开启 2-仅主持人可开启 */
  permission = undefined;
}

class YunxinSIPDeviceUIDAcquisitionResults {
  /** audio */
  audio = undefined;

  /** code */
  code = undefined;

  /** curtime */
  curtime = undefined;

  /** g2AppId */
  g2AppId = '';

  /** g2Key */
  g2Key = '';

  /** g2RoomToken */
  g2RoomToken = '';

  /** msg */
  msg = '';

  /** roomUid */
  roomUid = undefined;

  /** video */
  video = undefined;
}

export const client = {
  AccordingToYXUIDCheckTheInformation,
  AnnexInformationInTheConferenceRecord,
  AudioAndVideoConferenceLinkRegular,
  BriefInformationOfTheMeeting,
  CallParameter,
  CallSignal,
  CalledFangRefusedToAnswerParameters,
  CancelTheCallParameter,
  CancelTheEntranceCheckParameter,
  CheckTheParameters,
  CodeEditorStatus,
  CodePresetAtTheMeeting,
  ConferenceAppointmentResults,
  ConferenceConfigurationInformation,
  ConferenceConfigurationItem,
  ConferenceInformationV3,
  ConferenceInteractiveWhiteboardStatusInformation,
  ConferenceNotifyTheAuthenticationInformationConnection,
  ConferenceReactionConfiguration,
  ConferenceRecord,
  ConferenceRecordingRelatedStatus,
  ConferenceRecordingStatus,
  ConferenceShareScreenStatusInformation,
  ConferenceTranslatorConfiguration,
  ConferenceWebEntryConfigurationInformation,
  ConfigurationParametersOfTheSameInterpreter,
  ControlConfiguration,
  ControlInformation,
  CreateParametersOfTheScheduleMeeting,
  DetailsOfTheMeetingRecord,
  ExternalTerminalEntryState,
  FailureToQueryParametersWithoutList,
  Feedback,
  FocusOnModeInformation,
  FocusOnModeModificationParameters,
  G2AudioAndVideoParameter,
  GroupMeetingInformation,
  GroupMeetingsCreateParameters,
  HighlightInformation,
  InteractiveWhiteBanCloudCertificationParameters,
  InteractiveWhiteboardSnapshotFileUploadParameters,
  InterpretationCanBeAvailable,
  InterpretationLanguageChannel,
  InterpretationVoiceChannelSubscriptionParameters,
  JSONResponseObjectPackaging,
  LanguageChannelSubscriptionInformation,
  LanguageOption,
  LanguageSubChannel,
  MeetingApplication,
  MeetingChatRoomInformation,
  MeetingRecordDetailsQueryParameters,
  MemberDynamicSortSettingDto,
  ModeratorHandlesRecordingApplicationParameters,
  ModeratorModifyTheTitleParametersMeeting,
  ModeratorOperatingEquipmentCameraParameters,
  ModeratorOperatingEquipmentMicrophoneParameters,
  ModeratorProcessingTranscriptionApplicationParameters,
  ModeratorTransferParameter,
  ModifyTheChatRoomParameter,
  ModifyTheConferenceReactionConfigurationParameters,
  ModifyThePasswordConfigurationParametersMeeting,
  ModifyTheRecordingConfigurationParameter,
  ModifyTheSharedScreenPermissionParameters,
  ModifyTheSharedScreenStealsParameters,
  ModifyTheWebEntryParameters,
  MultipatedMeetingsToCreateParameters,
  OpenTheConferenceRecordingParameters,
  OpenTheTranscriptionParameter,
  P2PMeetingToParameters,
  ParticipantCallResult,
  ParticipantsSubscribeToTheSubChannel,
  ParticipateTheExteriorOfTheStatus,
  ParticipatingEquipmentModifyYourOwnParameters,
  ParticipatingEquipmentPeripherals,
  ParticipatingEquipmentThatIsRaisingHand,
  ParticipatorInformationV3,
  PasswordConfigurationInTheMeeting,
  PresetConfiguration,
  ReactionAvailableExpression,
  ReactionCanUseTheEmojiList,
  ReactionSettingDto,
  RecordingConfigurationItem,
  ReportExternalStatusParametersOnEquipment,
  SIPAttendeeAvatarConfiguration,
  SIPDevice,
  SIPDeviceIcon,
  SIPDeviceSearchResults,
  SIPIsCalledSquareInformation,
  SendEmojiParameters,
  ShareScreenAnnotationPermissionsModificationParameters,
  ShareScreenStatusModificationParameters,
  ShareSourceWindowSizeChangesParameters,
  SimilarInterpretationConfiguration,
  SimilarInterpretationStatusModificationParameters,
  SpeakerEnterAlgorithmV1Dto,
  SpeakerLeaveAlgorithmV1Dto,
  SpeakerTestAlgorithmConfiguration,
  StreamingPaginationDataPackaging,
  SubmitTheFeedbackParametersOfMeeting,
  SubtitleStompConnectionAuthenticationInformation,
  SubtitleTurnOnResultDto,
  SwitchSubtitleLanguageParameters,
  SwitchTranscriptionLanguageParameters,
  TextAvatar,
  TheConferenceIsContemporaryInterpretationStatus,
  TheHostModifyTheExternalParameters,
  TheHostPutDownTheParameter,
  TheHostReviseWhetherTheConfiguration,
  TheHostsInvitationPermissionsParametersMeeting,
  TheHostsMicrophoneToTurnParameters,
  TheInformationThatTheParticipantTime,
  TheLanguageAvailableInSubtitles,
  TheMeetingNoticeACKParameter,
  TheTranslatorModifyTheOutputResults,
  TimelineNode,
  Transcription,
  TranscriptionStatusInformation,
  TranslatorCandidate,
  TranslatorCandidateSearchResults,
  TranslatorConfiguration,
  TranslatorConfigurationModificationParameter,
  TranslatorsModifyTheVoiceOutputParameters,
  TurnOffSubtitleParameters,
  TurnOnSubtitleParameters,
  UserMeetingSettingInitForm,
  UserMeetingSettingUpdateForm,
  UserOperationParameters,
  WhiteboardExpressExportResult,
  WhiteboardSwitchParameters,
  YunxinSIPDeviceUIDAcquisitionResults,
};
